import React from 'react';
import { Drawer, Space, Card, Tag, Spin, Empty, Typography } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { fullDateTime } from '../../utils/dateTimeFormat';

const { Text } = Typography;

const VersionHistoryDrawer = ({ open, versions, loading, onClose }) => (
    <Drawer
        title={<Space><HistoryOutlined /><span>Version History</span></Space>}
        placement="right"
        width={600}
        open={open}
        onClose={onClose}
    >
        {loading ? (
            <div style={{ textAlign: 'center', padding: 40 }}><Spin size="large" /></div>
        ) : versions.length === 0 ? (
            <Empty description="No version history yet" />
        ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {versions.map((v) => (
                    <Card key={v.id} size="small" style={{ marginBottom: 8 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: 8 }}>
                            <div>
                                <Tag color="blue">v{v.version_number}</Tag>
                                <Text strong style={{ marginLeft: 8 }}>{v.change_summary}</Text>
                            </div>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                {v.created_at ? fullDateTime(v.created_at) : ''}
                            </Text>
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Tag color="default">{v.change_type}</Tag>
                            {v.snapshot && (
                                <div style={{ marginTop: 8, fontSize: 12, color: 'var(--color-text-secondary)' }}>
                                    <div>Files: {v.snapshot.file_count || 0}</div>
                                    {v.snapshot.file_sources && (
                                        <div>Sources: {v.snapshot.file_sources.file || 0} files, {v.snapshot.file_sources.webpage || 0} web pages</div>
                                    )}
                                </div>
                            )}
                        </div>
                    </Card>
                ))}
            </div>
        )}
    </Drawer>
);

export default VersionHistoryDrawer;
